import type { RouteObject } from "react-router";

/** Checkout needs a logged-in customer: the app mounts these under `RequireAuth`. */
export const checkoutRoutes: RouteObject = {
  path: "checkout",
  // focus mode (D34): no tab bar, the page's own bottom bar holds the main action
  handle: { shell: { tab: "cart", tabBar: false } },
  children: [
    {
      index: true,
      lazy: async () => ({ Component: (await import("./ui/CheckoutPage")).CheckoutPage }),
    },
    {
      path: "orders/:orderId/application",
      lazy: async () => ({ Component: (await import("./ui/ApplicationPage")).ApplicationPage }),
    },
    {
      path: "orders/:orderId/placed",
      handle: { shell: { tabBar: true } },
      lazy: async () => ({ Component: (await import("./ui/OrderPlacedPage")).OrderPlacedPage }),
    },
  ],
};
